import { forwardRef, useImperativeHandle, useState } from "react"
import { useTranslation } from "react-i18next"

import BasicButton from "@/components/button/BasicButton"

// PDF 생성 진행률 오버레이.
// 진행률 상태를 이 컴포넌트 내부에 격리해, generatePdf 의 잦은 진행률 갱신이
// 리포트/프리뷰 트리를 리렌더(재-캡처 중 churn·노드 detach)하지 않도록 한다.
export interface PdfProgressHandle {
  start: () => void
  setProgress: (value: number) => void
  finish: () => void
}

const PdfProgressOverlay = forwardRef<PdfProgressHandle, { onCancel?: () => void }>(
  ({ onCancel }, ref) => {
    const { t } = useTranslation()
    const [visible, setVisible] = useState(false)
    const [progress, setProgress] = useState(0)
    const [canceling, setCanceling] = useState(false)

    useImperativeHandle(ref, () => ({
      start: () => {
        setProgress(5)
        setCanceling(false)
        setVisible(true)
      },
      setProgress: (value: number) => setProgress(value),
      finish: () => {
        setVisible(false)
        setProgress(0)
        setCanceling(false)
      },
    }))

    if (!visible) {
      return null
    }

    return (
      <div className="pdf-loading-overlay">
        <div className="pdf-loading-content">
          <img
            src="/images/logo_horizontal.png"
            alt="Fitogether logo"
            className="pdf-loading-logo"
          />
          <div className="pdf-loading-progress">
            <div className="pdf-loading-bar">
              <div className="pdf-loading-bar-fill" style={{ width: `${progress}%` }} />
            </div>
            <div className="pdf-loading-percentage">{progress}%</div>
          </div>
          {onCancel && (
            <BasicButton
              type="default-outlined"
              size="md"
              disabled={canceling}
              onClick={() => {
                setCanceling(true)
                onCancel()
              }}>
              {/* 취소는 섹션 경계에서만 반영된다(캡처 중에는 메인 스레드가 막힘).
                  누른 직후 멈추지 않으므로 "취소 중" 을 보여 응답이 없다는 오해를 막는다. */}
              {canceling ? t("canceling", "Canceling...") : t("button.cancel")}
            </BasicButton>
          )}
        </div>
      </div>
    )
  },
)

PdfProgressOverlay.displayName = "PdfProgressOverlay"

export default PdfProgressOverlay
